/** Staggered blocks for pricing pages (aligned with `HeroSection` image `AnimatedGroup` item motion). */
export const pricingSectionBlockVariants = {
    container: {
        visible: { transition: { delayChildren: 1, staggerChildren: 0.12 } },
    },
    item: {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { type: 'spring' as const, bounce: 0.3, duration: 2 },
        },
    },
} as const
